export const GET_FISCAL_YEARS = 'GET_FISCAL_YEARS';
export const GET_FISCAL_YEARS_LOADING = 'GET_FISCAL_YEARS_LOADING';
export const GET_FISCAL_YEARS_ERROR = 'GET_FISCAL_YEARS_ERROR';



// WEBPACK FOOTER //
// ./src/state/fiscalYears/types.js